import React, { useRef, useState, useEffect, useCallback } from 'react';
import _ from 'lodash';
import { Button, Divider, Tooltip, } from 'antd';
import { Resizable } from 'react-resizable';

import { SvgIconText } from 'freesia-ui';

import { Application } from "@yulintu/freesia-bootstrap";

import DiagramUtils from '../designer/utils/DiagramUtils';
import DiagramDesigner from "../designer/DiagramDesigner";
import PropertyGrid from "../PropertyGrid/PropertyGrid";
import Toolbar from "./Toolbar";
import SiderController from "./SiderController";
import SiderToolbarController from "./SiderToolbarController";

import { } from "./diagrams/Page/PageUI";
import { } from "./diagrams/Rectangle/RectangleUI";
import { } from "./diagrams/Ellipse/EllipseUI";
import { } from "./diagrams/Text/TextUI";

import './index.less';
import 'freesia-ui/src/css/fonts.less';

export const Context = React.createContext();

export default function PlotDesigner(props) {

    const refDesigner = useRef();
    const [flag, setFlag] = useState();

    useEffect(() => {
        setTimeout(() => {
            setFlag({});
        }, 0);
    }, []);

    useEffect(() => {

        if (!refDesigner.current)
            return;

        const unregisterSelectedItemsChangedListener = refDesigner.current.registerSelectedItemsChangedListener(items => {
            setFlag({});
        });

        return () => {
            unregisterSelectedItemsChangedListener();
        };

    }, []);

    useEffect(() => {

        if (!refDesigner.current?.eventEmitter)
            return;

        const callback = e => {
            setFlag({});
        }

        refDesigner.current?.eventEmitter.on("refresh", callback);

        return () => {
            refDesigner.current?.eventEmitter.off("refresh", callback);
        }

    }, [refDesigner.current?.eventEmitter]);

    return (
        <Context.Provider value={{
            designer: refDesigner.current,
            eventEmitter: refDesigner.current?.eventEmitter
        }}>
            <div {...props} className={'plot-designer ' + (props.className || "")}>
                <DiagramDesigner
                    ref={refDesigner}
                    paper={{
                        backgroundColor: "transparent",
                        borderWidth: 0,
                        viewShadowEnabled: false,
                        viewBackgroundColor: "transparent",
                    }} />
                {
                    refDesigner.current && <div className='ui-layer'>
                        {
                            (props.addons || []).filter(c => !c.location).map((c, i) => {
                                return (
                                    <c.Component key={i + ""} {...c.props} metadata={c} />
                                );
                            })
                        }
                        <div className="topbar">
                            <div className='left'>
                                <SiderToolbarController location="sider-left" addons={props.addons} />
                                <Toolbar location="top-left" addons={props.addons} />
                            </div>
                            <div className='center'>
                                <Toolbar location="top-center" addons={props.addons} />
                            </div>
                            <div className='right'>
                                <Toolbar location="top-right" addons={props.addons} />
                                <SiderToolbarController location="sider-right" addons={props.addons} />
                            </div>
                        </div>
                        <div className="content">
                            <div className='left'>
                                <SiderController location="sider-left" addons={props.addons} />
                            </div>
                            <div className='content'>
                                {
                                    (props.addons || []).filter(c => c.location === "content").map((c, i) => {
                                        return (
                                            <c.Component key={i + ""} {...c.props} metadata={c} />
                                        );
                                    })
                                }
                            </div>
                            <div className='right'>
                                <SiderController location="sider-right" addons={props.addons} />
                            </div>
                        </div>
                        <div className="bottombar">
                            <div className='left'>
                                <Toolbar location="bottom-left" addons={props.addons} />
                            </div>
                            <div className='center'>
                                <Toolbar location="bottom-center" addons={props.addons} />
                            </div>
                            <div className='right'>
                                <Toolbar location="bottom-right" addons={props.addons} />
                            </div>
                        </div>
                    </div>
                }
            </div>
        </Context.Provider>
    );
}